<template>
    <div>
       <vs-button
       @click.prevent="createOauthApi()"
       >QUick Book</vs-button>

    </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import {quickBookOauthApi} from '@/api/quickBook'
export default {
  components:{
    AgGridVue
  },
  data () {
    return {
      columnDefs:[]
    }
  },
  mounted () {
    this.columnDefs = [
      { field: 'country', rowGroup: true },
      { field: 'sport', rowGroup: true }
    ]
  },
  methods:{
    async createOauthApi () {
      try {
        const {data} = await quickBookOauthApi()
        
        window.open(data.data.auth_url, '_blank')  

      } catch (error) {
        
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>